const fontWeightNormal = 400;
const fontWeightBold = 700;
export const helveticaBold = '"Helvetica Neue LT W05_75 Bold", Arial, sans-serif';
export const helveticaRoman = '"Helvetica Neue LT W05_55 Roman", Arial, sans-serif';

export const typographStyles = {
    h1: {
        fontSize: '2.125rem',
        lineHeight: '2.5rem',
        fontWeight: fontWeightNormal,
        '@media (max-width:768px)': {
            fontSize: '2rem',
            lineHeight: '2.5rem',
        },
    },
    h2: {
        fontSize: '1.625rem',
        lineHeight: '2rem',
        fontWeight: fontWeightNormal,
        '@media (max-width:768px)': {
            fontSize: '1.5rem',
            lineHeight: '2rem',
        },
    },
    h3: {
        fontSize: '1.375rem',
        lineHeight: '1.75rem',
        fontWeight: fontWeightBold,
        '@media (max-width:768px)': {
            fontSize: '1.25rem',
            lineHeight: '1.75rem',
        },
    },
    h4: {
        fontSize: '1.125rem',
        lineHeight: '1.5rem',
        fontWeight: fontWeightBold,
        '@media (max-width:768px)': {
            fontSize: '1rem',
            lineHeight: '1.5rem',
        },
    },
    h5: {
        fontSize: '1rem',
        lineHeight: 1.5,
        fontWeight: fontWeightBold,
        '@media (max-width:768px)': {
            fontSize: '.875rem',
            lineHeight: '1.25rem',
        },
    },
    h6: {
        fontSize: '.875rem',
        lineHeight: '1.25rem',
        fontWeight: fontWeightBold,
        '@media (max-width:768px)': {
            fontSize: '.75rem',
            lineHeight: '1.125rem',
        },
    },
    body1: {
        fontSize: '.875rem',
        lineHeight: '1.25rem',
        fontWeight: fontWeightNormal,
    },
    body2: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
        fontWeight: fontWeightNormal,
    },
    caption: {
        fontSize: '.75rem',
        lineHeight: '1.255rem',
        fontWeight: fontWeightNormal,
    },
    subtitle1: {
        fontSize: '.875rem',
        lineHeight: '1.25rem',
        fontWeight: fontWeightBold,
    },
    inputLabel: {
        fontSize: '0.875rem',
        lineHeight: '1.42857',
        letterSpacing: '0.015rem',
        fontFamily: helveticaBold,
    },



};